<template>
  <div class="container">
    <div class="white-frame">
      <div class="title-text mb-3"><b>Produtos</b></div>
      <div class="custom-card-grid-3x3">
        <router-link
          v-for="product in products"
          :key="product.path"
          class="custom-card mob-w100"
          tag="div"
          :to="{ name: product.name, params: { ids: product.ids } }"
        >
          <div class="c-card-icon"><i :class="product.icon"></i></div>
          <div class="px-2">
            <div class="c-card-Title">{{ product.desc }}</div>
            <!-- <div class="c-card-descr">descrição item</div> -->
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { AxaRamos } from "../utils/constants";
export default {
  data() {
    return {
      products: null,
    };
  },
  mounted() {
    this.products = AxaRamos;
  },
};
</script>
